/*
 * Created on Wed Oct 11 2023 4:56:55 PM
 *
 * ***************************************************************************************
 * Copyright (c) AVPS Technologies Inc 2023 
 *
 * All Rights Reserved
 * Unpublished rights are reserved under the copyright laws of the United States.
 * The software contained in this media is proprietary to and embodies confidential
 * the technology of AVPS Technologies Inc. Possession, use, duplication or
 * dissemination of the software and media is authorized only pursuant to a valid
 * written license from AVPS Technologies Inc.
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * RESTRICTED RIGHTS LEGEND Use, duplication, or disclosure by the U.S. Government
 * is subject to restrictions as set forth in Subparagraph (c) (1) (ii) of DFARS
 * 252.227-7013 or in FAR 52.227-19, as applicable.
 ****************************************************************************************
 */

import { motion } from 'framer-motion';
import { Building2, Info } from 'lucide-react';

const ProductImage = ({ product, isKiosk }) => {
  return (
    <motion.div
      whileHover={{ scale: 1.01 }}
      transition={{ duration: 0.2 }}
      className={`relative bg-slate-100 rounded-2xl overflow-hidden shadow-md ${isKiosk ? 'h-56 sm:h-64' : 'h-80'}`}
    >
      {product?.imageContents?.[0]?.displayLink ? (
        <>
          <img
            src={product?.imageContents?.[0]?.displayLink}
            alt={product.name}
            className="w-full h-full object-cover"
          />
          <div className="absolute top-4 right-4 bg-slate-800/80 backdrop-blur-sm px-3 py-1.5 flex items-center space-x-1.5 rounded-lg">
            <Info className="w-3 h-3 text-slate-300" />
            <span className="text-xs font-medium text-slate-200">Illustrative purposes only</span>
          </div>
        </>
      ) : (
        <div className="w-full h-full bg-gradient-to-br from-slate-100 to-slate-200 flex items-center justify-center">
          <Building2 className="w-16 h-16 text-slate-400" />
        </div>
      )}
    </motion.div>
  );
};

export default ProductImage;